export default __webpack_public_path__ + "static/media/case-study-right.b3d8ab83.png";